import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LayoutDashboard, BikeIcon, Users, CreditCard, MapPin, Clock, UserCog, ClipboardList, Package, FileSpreadsheet } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { getBranchName } from "@/integrations/supabase/services";

const Sidebar = () => {
  const location = useLocation();
  const { profile } = useAuth();

  // Fetch branch information for operators
  const { data: branch } = useQuery({
    queryKey: ['branch', profile?.branch_id],
    queryFn: () => getBranchName(profile?.branch_id || ''),
    enabled: !!profile?.branch_id && profile?.role === 'operator'
  });

  const superAdminItems = [
    { icon: <LayoutDashboard size={20} />, label: "Panel Principal", path: "/" },
    { icon: <BikeIcon size={20} />, label: "Alquileres", path: "/rentals" },
    { icon: <Users size={20} />, label: "Clientes", path: "/customers" },
    { icon: <ClipboardList size={20} />, label: "Bicicletas", path: "/bikes" },
    { icon: <CreditCard size={20} />, label: "Planes", path: "/plans" },
    { icon: <MapPin size={20} />, label: "Sucursales", path: "/branches" },
    { icon: <Clock size={20} />, label: "Jornadas", path: "/shifts" },
    { icon: <UserCog size={20} />, label: "Usuarios", path: "/users" },
    { icon: <CreditCard size={20} />, label: "Pagos", path: "/payments" },
    { icon: <Package size={20} />, label: "Inventario", path: "/inventory" },
    { icon: <FileSpreadsheet size={20} />, label: "Reportes", path: "/reports" },
  ];

  const branchAdminItems = [
    { icon: <LayoutDashboard size={20} />, label: "Panel Principal", path: "/" },
    { icon: <BikeIcon size={20} />, label: "Alquileres", path: "/rentals" },
    { icon: <Users size={20} />, label: "Clientes", path: "/customers" },
    { icon: <ClipboardList size={20} />, label: "Bicicletas", path: "/bikes" },
    { icon: <CreditCard size={20} />, label: "Planes", path: "/plans" },
    { icon: <Clock size={20} />, label: "Jornadas", path: "/shifts" },
    { icon: <UserCog size={20} />, label: "Usuarios", path: "/users" },
    { icon: <CreditCard size={20} />, label: "Pagos", path: "/payments" },
    { icon: <Package size={20} />, label: "Inventario", path: "/inventory" },
    { icon: <FileSpreadsheet size={20} />, label: "Reportes", path: "/reports" },
  ];

  const operatorItems = [
    { icon: <LayoutDashboard size={20} />, label: "Panel Principal", path: "/" },
    { icon: <BikeIcon size={20} />, label: "Alquileres", path: "/rentals-operator" },
    { icon: <Users size={20} />, label: "Clientes", path: "/customers" },
    { icon: <ClipboardList size={20} />, label: "Mis Bicicletas", path: "/bikes-operator" },
    { icon: <CreditCard size={20} />, label: "Planes", path: "/plans-operator" },
    { icon: <Clock size={20} />, label: "Jornadas", path: "/shifts" },
    { icon: <Package size={20} />, label: "Inventario", path: "/inventory" },
  ];

  const menuItems = profile?.role === 'super_admin' ? superAdminItems : profile?.role === 'branch_admin' ? branchAdminItems : operatorItems;
  //const isActive = (path: string) => location.pathname === path;

  return (
    <div className="flex flex-col w-64 bg-white border-r border-gray-200">
      <div className="flex items-center justify-center h-16 border-b border-gray-200">
        <img src="images/logo.png" alt="Logo" style={{ height: '50px', maxWidth: 'auto' }} />
      </div>
      
      {/* Show branch name for operators */}
      {profile?.role === 'operator' && branch && (
        <div className="px-4 py-2 border-b border-gray-200">
          <p className="text-sm text-gray-600 font-medium">{branch.name}</p>
        </div>
      )}

      <div className="flex flex-col flex-1 overflow-y-auto">
        <nav className="flex-1 px-2 py-4 space-y-1">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.label}
              to={item.path}
              className={cn(
                "flex items-center px-4 py-3 text-sm font-medium rounded-md transition-colors",
                isActive
                  ? "bg-bike-50 text-bike-600"
                  : "text-gray-600 hover:bg-bike-50 hover:text-bike-600"
              )}
            >
              <span className="mr-3">{item.icon}</span>
              {item.label}
            </Link>
          );
        })}
        </nav>
      </div>
    </div>
  );
}

export default Sidebar;
